<template>
  <div class="logo-full-signature-content" id="identidade-visual-logo-assinatura-completa" data-search-anchor>
    <div class="title-full-signature-wrapper">
      <h1 class="logo-full-signature-title-span">{{ logoFullSignatureTitleSpan }}</h1>
      <h1 class="logo-full-signature-title">{{ logoFullSignatureTitle }}</h1>
    </div>

    <div class="description-full-signature-wrapper">      
      <p class="logo-full-signature-description">{{ logoFullSignatureDescription }}</p>
      <p></p>
      <p class="logo-full-signature-description">{{ logoFullSignatureDescription1 }}</p>
      <div class="logo-full-signature-icon-wrapper-icon">
        <p class="logo-full-signature-importante">{{ logoFullSignatureDescription2 }}</p>
        <div class="logo-full-signature-texts-important" >
          <IconCancel />
          <p class="logo-full-signature-description-second">{{ logoFullSignatureDescription3 }}</p>
        </div>
      </div>
    </div>

    <div class="logo-full-signature-card-item" :style="{ backgroundImage: `url(${logoFullSignatureImageSrc})` }"></div>
    <div class="button-full-signature-wrapper">
      <RedirectOneDriveButton
          :linkUrl="onedriveUrl"
          buttonText="Baixar assinatura"
      />    
      
    </div>

    <div class="description-full-signature-wrapper">
      <div>
        <p class="logo-full-signature-description">{{ logoFullSignatureDescription4 }}</p>
        <p class="logo-full-signature-description">{{ logoFullSignatureDescription5 }}</p>
        <p class="logo-full-signature-description">{{ logoFullSignatureDescription6 }}</p>
      </div>
    </div>
    <div class="logo-full-signature-card-item-2" :style="{ backgroundImage: `url(${logoFullSignatureImageSrc2})` }">
    </div>
    
    <div class="logo-full-signature-card-item-3" :style="{ backgroundImage: `url(${logoFullSignatureImageSrc3})` }">
    </div>

    <div class="description-full-signature-wrapper">
      <div class="logo-full-signature-icon-wrapper">
        <IconCheck />
        <p class="logo-full-signature-description-second" >
          {{ logoFullSignatureDescription10 }}
        </p>
      </div>
    </div>
    <div class="logo-full-signature-card-item-4" :style="{ backgroundImage: `url(${logoFullSignatureImageSrc4})` }">
    </div>
    
    <div class="logo-full-signature-card-item-5" :style="{ backgroundImage: `url(${logoFullSignatureImageSrc5})` }">
    </div>

    <div class="description-full-signature-wrapper">
      <div class="logo-full-signature-icon-wrapper" >
        <IconCheck />
        <p class="logo-full-signature-description-second">
          {{ logoFullSignatureDescription12 }}
        </p>
      </div>
    </div>
    <div class="logo-full-signature-card-item-6" :style="{ backgroundImage: `url(${logoFullSignatureImageSrc6})` }">
    </div>
    
  </div>
</template>

<script lang="ts">
import { PageStoreContract } from '@/data/store/page.store.contract'
import VisualIdentityPageMixin from '@/mixins/visual-identity-page-mixin'
import { VisualIdentityPageStore } from '@/store/visual-identity-page/visual-identity-store'
import { Component, Mixins } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import IconCancel from '@/assets/icons/IconCancel.vue'
import IconCheck from '@/assets/icons/IconCheck.vue'

@Component({
  components: {
    IconCancel,
    IconCheck,    
  }
})
export default class LogoFullSignatureSection extends Mixins(VisualIdentityPageMixin) {
  visualIdentityPageStore: PageStoreContract = getModule(VisualIdentityPageStore, this.$store)

  onedriveUrl = 'https://tvglobocorp.sharepoint.com/sites/intranetconexao/DocumentosMarca/Assinatura%20Completa'

  get logoFullSignatureTitleSpan(): string {
    return this.getElementTitle(15, 0)
  }

  get logoFullSignatureTitle(): string {
    return this.getElementText(15, 0)
  }

  get logoFullSignatureDescription(): string {
    return this.getElementText(15, 1)
  }

  get logoFullSignatureDescription1(): string {
    return this.getElementText(15, 2)
  }

  get logoFullSignatureDescription2(): string {
    return this.getElementText(15, 3)
  }

  get logoFullSignatureDescription3(): string {
    return this.getElementText(15, 4)
  }

  get logoFullSignatureImageSrc(): string {
    return this.getElementMedia(15, 5)
  }
  //end sub section-1

  get logoFullSignatureDescription4(): string {
    return this.getElementText(15, 6)
  }

  get logoFullSignatureDescription5(): string {
    return this.getElementText(15, 7)
  }

  get logoFullSignatureDescription6(): string {
    return this.getElementText(15, 8)
  }

  get logoFullSignatureImageSrc2(): string {
    return this.getElementMedia(15, 9)
  }
  //end sub section-2

  get logoFullSignatureImageSrc3(): string {
    return this.getElementMedia(15, 10)
  }
  //end sub section-3

  get logoFullSignatureDescription10(): string {
    return this.getElementText(15, 11)
  }

  get logoFullSignatureImageSrc4(): string {
    return this.getElementMedia(15, 12)
  }
  //end sub section-4

  get logoFullSignatureImageSrc5(): string {
    return this.getElementMedia(15, 13)
  }
  //end sub section-5

  get logoFullSignatureDescription12(): string {
    return this.getElementText(15, 14)
  }

  get logoFullSignatureImageSrc6(): string {
    return this.getElementMedia(15, 15)
  }  

  async getVisualIdentityPage(): Promise<void> {
    await this.visualIdentityPageStore.getDataPage()
  }

  async mounted(): Promise<void> {
    if (!this.visualIdentityPageStore.isLoading) {
      await this.getVisualIdentityPage()
    }
  }
}
</script>

<style lang="scss">
.logo-full-signature-content {
  display: grid;
  width: 100%;
  max-width: 1032px;
}

.title-full-signature-wrapper {
  display: flex;
  align-items: center;
  height: 6vh;
  padding-top: 6.25rem;
  padding-bottom: 1rem;
}

.logo-full-signature-title-span {
  font-size: 30px;
  font-weight: 700;
  line-height: 57px;
  letter-spacing: -0.01em;
  text-align: left;

  margin-right: 5px;
  color: #b3b3b3;
}

.logo-full-signature-title {
  font-size: 30px;
  font-weight: 700;
  line-height: 57px;
  letter-spacing: -0.01em;
  text-align: left;

  color: #000000;
}

.logo-full-signature-description,
.logo-full-signature-description-first {
  font-size: 16px;
  font-weight: 600;
  line-height: 20px;
  text-align: left;
  
  width: 430px;  
}

.logo-full-signature-description-first{
  margin-top: 2rem;
}

.logo-full-signature-importante {
  font-size: 16px;  
  line-height: 20px;
  text-align: left;
  margin-bottom: 0;
  width: 378px;
  font-family: InterVariableBold;  
}

.logo-full-signature-description-second {
  font-size: 16px;
  font-weight: 600;
  line-height: 20px;
  text-align: left;  
  padding-left: 7px;
  width: 378px; 
}

.logo-full-signature-icon-wrapper {
  display: flex;
  align-items: center;    
}

.logo-full-signature-card-item {
  position: relative;
  bottom: 0;  

  max-width: 1032px;
  width: 100%;
  height: 705px;

  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
}

.logo-full-signature-card-item-2,
.logo-full-signature-card-item-3,
.logo-full-signature-card-item-4,
.logo-full-signature-card-item-5,
.logo-full-signature-card-item-6 {
  position: relative;  
  width: 100%;
  max-width: 1032px;
  height: 705px;
  //border-radius: 20px;  
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;  
}

.logo-full-signature-card-item-2,
.logo-full-signature-card-item-3 {  
  bottom: 0;  
}

.logo-full-signature-card-item-2,
.logo-full-signature-card-item-4 {
  margin-bottom: 1rem;
}

.logo-full-signature-card-item-3,
.logo-full-signature-card-item-5 {  
  margin-bottom: 2rem;  
}

.button-full-signature-wrapper {
  display: flex;
  align-items: center;
  padding-top: 2rem;
  padding-bottom: 2rem;
}

.description-full-signature-wrapper {  
  position: relative;
  display: grid;
  grid-template-columns: 50% 50%;  
}

.logo-full-signature-texts{
  display: flex;
  align-items: center;
}

.logo-full-signature-texts-important{
  display: flex;  
  align-items: center;  
}
</style>
